import PATHS from '../constants';

function fetchBlogPortada(id) {
    const url = PATHS.BLOG_PORTADA;
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };
    return fetch(url, {
        method: 'GET',
        dataType: 'json',
        headers,
    });
};

export default fetchBlogPortada;